module.exports = {"pathContext":{"name":"CustomVitalInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"value","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-custom-vital-input.json
// module id = 1421
// module chunks = 248415211019483